import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {sendEvarData, logPageLoadEvents} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';
import AppButon from '../AppButon/AppButon';
import SelectLanguage from '../SelectLanguage/SelectLanguage';
import OnboardingNew from '../../OnboardingNew';
import Step1 from '../Steps/Step1';
import Spinner from '../Spinner/Spinner';
import {submitLicenseDetails, submitTrnDetails} from '../../../../../store/actions/thunk';
import {
  redirectToSameWindowWithoutRefresh,
  getUrlWithCrid,
  getCrid,
} from '../../../../../../../myaccount/src/utils/redirectWithCrId';
import * as S from './CreateAccount.styles';
import {tokenSelector, errorSelector} from '../../../../../store/selectors';
import {UPLOAD_PASSPORT_DETAILS} from '../../../../../constants';

const CreateAccount = () => {
  const crId = getCrid();
  if (!crId) {
    redirectToSameWindowWithoutRefresh('/agent/upload-passport-details');
  }
  const initialWindow = {
    screen: 100,
  };
  const winSize = typeof window === 'undefined' ? initialWindow.screen : window.screen;
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector(tokenSelector);
  const error = useSelector(errorSelector);

  const [filePath, setFilePath] = useState('');
  const [fileType, setFileType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [approve, setApprove] = useState(false);
  const [steps, setSteps] = useState(0);
  const [fileData, setFileData] = useState(null);
  const [trnNumber, setTrnNumber] = useState('');
  const [responseData, setResponseData] = useState(null);
  const [licenseNumber, setLicenseNumber] = useState('');
  const [disabledInput, setDisabledInput] = useState(false);
  const [disableSubmitButton, setDisableSubmitButton] = useState(true);
  const [busineesDetails, setBusinessDetails] = useState({
    business_name: '',
    expiry_date: '',
    address: '',
    business_desc: '',
    emirates: '',
  });
  const [licenseNumberResponse, setLicenseNumberResponse] = useState({});
  const [trnLoader, setTrnLoader] = useState(false);

  useEffect(() => {
    const onPageLoad = () => {
      logPageLoadEvents('onboarding:businessdetails|mypartner', {
        eVar15: 'onboarding:businessdetails|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/upload-license',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      });
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  useEffect(() => {
    let flag = false;
    for (const key in busineesDetails) {
      if (key !== 'trn_number' && busineesDetails[key] === '') {
        flag = true;
      }
    }

    if (flag === true) {
      setDisableSubmitButton(true);
    } else setDisableSubmitButton(false);
  }, [busineesDetails]);

  const handleSteps = () => {
    setTrnLoader(true);
    if (!licenseNumberResponse?.is_editable) {
      if (!trnNumber)
        logPageLoadEvents('onboarding:signup:landing', {
          eVar15: 'onboarding:businessdetails|mypartner',
          channel: 'onboarding|mypartner',
          prop24: 'onboarding|mypartner',
          eVar24: 'onboarding|mypartner',
          prop27: '/agent/upload-license',
          eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
          prop54: 'myPartner_onboarding_TRN_absent',
        });
      dispatch(
        submitTrnDetails(
          {business_name: responseData?.data?.business_name},
          token,
          handleSubmitTrnSuccess,
          handleSubmitTrnError,
        ),
      );
    } else {
      if (!busineesDetails?.trn_number) {
        if (!trnNumber)
          logPageLoadEvents('onboarding:signup:landing', {
            eVar15: 'onboarding:businessdetails|mypartner',
            channel: 'onboarding|mypartner',
            prop24: 'onboarding|mypartner',
            eVar24: 'onboarding|mypartner',
            prop27: '/agent/upload-license',
            eVar37:
              'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
            prop54: 'myPartner_onboarding_TRN_absent',
          });
      }
      dispatch(
        submitTrnDetails(
          {...busineesDetails, ed_license_number: licenseNumber},
          token,
          handleSubmitTrnSuccess,
          handleSubmitTrnError,
        ),
      );
    }
  };

  const getFileInfo = info => {
    setFileType(info[0].type);
  };

  const selectFile = val => {
    setFilePath(val);
  };

  const handleSubmitLicenseSuccess = resp => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_LN_verification_true',
    });

    if (resp?.data) {
      const obj = busineesDetails;
      for (const i in resp?.data) {
        obj[i] = resp.data[i];
      }
      setBusinessDetails(obj);
    }

    if (!resp?.is_editable) {
      setDisableSubmitButton(false);
    }
    if (resp?.manual_qc) {
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:businessdetails|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/upload-license',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'manual_qc=true',
      });
    }
    setLicenseNumberResponse(resp);
    setIsLoading(false);
    setResponseData(resp);
    setApprove(true);
  };

  const handleSubmitLicenseErrorCallback = error => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_LN_verification_false',
    });
    setIsLoading(false);
    setDisabledInput(false);
    if (error?.is_editable) {
      setResponseData(error);
      setApprove(true);
    }
  };

  const onApprove = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_uploadApprove',
    });
    setIsLoading(true);
    setDisabledInput(true);
    dispatch(
      submitLicenseDetails(
        {licence_number: licenseNumber, trading_license_doc: fileData},
        token,
        handleSubmitLicenseSuccess,
        handleSubmitLicenseErrorCallback,
      ),
    );
  };

  const handleSubmitTrnSuccess = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_TRN_verification_true',
    });
    setTrnLoader(false);
    history.push(`${UPLOAD_PASSPORT_DETAILS}?crId=${getCrid()}`);
  };

  const handleSubmitTrnError = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_TRN_verification_false',
    });
    setTrnLoader(false);
  };

  const onBackPress = () => {
    setSteps(step => step - 1);
  };

  const makeid = length => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  return (
    <OnboardingNew step={2}>
      <S.Container>
        {/*<S.CaHeader border={steps > 2 && winSize.width <= 767}>
          <BackButton arrow={true} onBackPress={onBackPress} />
          <S.CaHeaderRight>
            {steps > 2 && winSize.width >= 768 && <SelectLanguage />}
            <SessionTag />
            <Step classes="appendLeft10" maxStep={3} minStep={steps + 1} />
          </S.CaHeaderRight>
  </S.CaHeader>*/}
        <S.Content>
          {steps > 2 && winSize.width <= 767 && <SelectLanguage classes={'appendBottom20'} />}
          {steps === 0 && (
            <Step1
              setFileData={setFileData}
              approveFileHandler={onApprove}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              responseData={responseData}
              setTrnNumber={setTrnNumber}
              licenseNumber={licenseNumber}
              setLicenseNumber={setLicenseNumber}
              approve={approve}
              busineesDetails={busineesDetails}
              setBusinessDetails={setBusinessDetails}
              disabledInput={disabledInput}
              setDisabledInput={setDisabledInput}
              setApprove={setApprove}
            />
          )}
        </S.Content>
        {error?.msg && <S.ErrorMsg>{error.msg}</S.ErrorMsg>}
        {(!filePath || approve) && steps < 3 && (
          <S.ContentFooter>
            <AppButon
              buttonText={'Save & Continue'}
              isDisabled={disableSubmitButton}
              onPress={handleSteps}
              isError={false}
              classes={''}
              butonWidth="40px"
              isLoading={trnLoader}
            />
            <p className="textCenter greyText font12 appendTop5">
              By proceeding, you agree to MakeMyTrip's T&Cs and Privacy Policy
            </p>
          </S.ContentFooter>
        )}
      </S.Container>
    </OnboardingNew>
  );
};

export default CreateAccount;
